module.exports = __webpack_public_path__ + "components/flag/static/square/vn-283c662e413217d5cd76b165aaa1a6fc.svg";